import { render, staticRenderFns } from "./VuesticScrollbar.vue?vue&type=template&id=4636c35e&"
import script from "./VuesticScrollbar.vue?vue&type=script&lang=js&"
export * from "./VuesticScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./VuesticScrollbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticScrollbar.vue"
export default component.exports